import { DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '@sb/ui/button';
import { SbDialogSharedModule } from '@sb/ui/dialog';
import { IconComponent } from '@sb/ui/icon';
import { QuotaType } from '@shiftbase-com/ts-shared/models';

import { SwitchToFreeDialogData } from './switch-to-free-dialog.model';

@Component({
  selector: 'switch-to-free-dialog',
  templateUrl: './switch-to-free-dialog.component.html',
  imports: [TranslatePipe, ButtonComponent, IconComponent, SbDialogSharedModule],
})
export class SwitchToFreeDialogComponent {
  data = inject<SwitchToFreeDialogData>(DIALOG_DATA);

  quotaType = QuotaType;
}
